export enum PRProcessingStatus {
	Queued = 1,
	InProgress = 2,
	CompletedSuccessfully = 3,
	CompletedWithErrors = 4,
	Canceled = 5,
}
